import {
  AclEntityResourceBitMap,
  AclResources, AclResourcesBitMap,
  IAclByRoleType,
} from 'src/app/shared/types/acl.types';

export const aclByRoleTypeToEntityResourceMapper = (aclRoleByType: IAclByRoleType|IAclByRoleType[]): AclEntityResourceBitMap => {
  const items = Array.isArray(aclRoleByType)
    ? aclRoleByType.flatMap(group => group.items)
    : aclRoleByType.items;

  return items
    .reduce((acc, group) => ({
      ...acc,
      [group.id]: group.resources.reduce((acc, resource) => ({
        ...acc,
        [resource]: true,
      }), {}),
    }), {});
};

export const aclResourcesToMap = (aclResources: AclResources): AclResourcesBitMap =>
  aclResources.reduce((acc, resource) => ({
    ...acc,
    [resource]: true,
  }), {});
